import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

import { Input, Select } from 'components/atoms';
import { Section } from 'components/molecules/TabPanel/TabPanel';
import { useGetPicklistQuery } from 'services/sap';
import { catalogoLenguage, catalogoPersonal } from 'utils/helpers/dictionaries';
import { formTypes, IProfileForm } from 'utils/interfaces';

import { useProfileFormContext } from '../hooks/useProfileFormContext';

interface ITabEducationProps {
  formValues: IProfileForm;
  isDisabled: boolean;
  changeData: (value: { name: formTypes; value?: number | string }) => Promise<void>;
  isEditing: boolean;
}

export const TabEducation = ({ formValues, isDisabled, changeData }: ITabEducationProps) => {
  const {
    register,
    formState: { errors },
  } = useFormContext();
  const { profileData } = useProfileFormContext();
  const { data: degreeDataRaw, isLoading } = useGetPicklistQuery({
    catalogName: catalogoPersonal.degree,
    languages: [catalogoLenguage.ESyOptionId],
  });
  const degreeData = degreeDataRaw?.filter((v: any) => !v.status || v.status === 'A');

  const fillDefaultData = () => {
    if (profileData) {
      !formValues.educationLevel &&
        changeData({ name: 'educationLevel', value: profileData.educationLevel });
      !formValues.institution &&
        changeData({ name: 'institution', value: profileData.institution });
      !formValues.title && changeData({ name: 'title', value: profileData.title });
    }
  };

  useEffect(() => {
    if (profileData) {
      fillDefaultData();
    }
    // eslint-disable-next-line
  }, [profileData]);

  return (
    <Section id={2}>
      <section className='section-form'>
        <aside className='section-form__aside'>
          <article className='section-form__article'>
            {isDisabled ? (
              <Input
                id='educationLevel'
                label='Nivel educativo (último/actual)'
                placeholder=''
                type='text'
                register={register}
                value={formValues.educationLevel}
                disabled
              />
            ) : (
              <Select
                className='section-form__select'
                htmlForLabel={'educationLevel'}
                selected={formValues?.educationLevel ?? ''}
                disabled={isLoading || isDisabled}
                handleChange={(value) => changeData({ name: 'educationLevel', value })}
                options={degreeData?.map((v: any) => ({ label: v.label_es_ES, value: v.label_es_ES }))}
                textLabel={'Nivel educativo (último/actual)'}
                placeholder={'Selecciona'}
                error={!!errors?.educationLevel}
              />
            )}
          </article>
          <article className='section-form__article'>
            <Input
              {...register('institution', { required: 'El nivel académico es obligatorio' })}
              id='institution'
              label='Institución'
              type='text'
              placeholder='Ej: Universidad Nacional'
              value={formValues.institution}
              onChange={(e) => {
                const { value } = e.currentTarget;
                changeData({ name: 'institution', value });
              }}
              disabled={isDisabled}
              register={register}
              error={!!errors?.institution}
            />
          </article>
        </aside>
        <aside className='section-form__aside'>
          <article className='section-form__article'>
            <Input
              id='title'
              label='Título obtenido'
              type='text'
              placeholder='Ej: Ingeniero'
              value={formValues.title}
              onChange={(e) => {
                const { value } = e.currentTarget;
                changeData({ name: 'title', value });
              }}
              disabled={isDisabled}
              register={register}
              error={!!errors?.title}
            />
          </article>
        </aside>
      </section>
    </Section>
  );
};
